var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dd",
    { class: _vm._f("klass")(_vm.validate.$error) },
    [
      _vm.validate.$error
        ? [
            !_vm.validate.required
              ? _c("span", { staticClass: "errNote" }, [
                  _vm._v("町域番地を入力してください。"),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.validate.$invalid
        ? [
            !_vm.validate.zenhankakuRule
              ? _c("span", { staticClass: "errNote" }, [
                  _vm._v("使用できない文字が含まれています。"),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.validate.zenkakuMaxLength
              ? _c("span", { staticClass: "errNote" }, [
                  _vm._v("町域番地は26文字以下で入力してください。"),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.lazy",
            value: _vm.validate.$model,
            expression: "validate.$model",
            modifiers: { lazy: true },
          },
        ],
        staticClass: "regular",
        attrs: {
          name: "address_street",
          type: "text",
          id: "js-address-street",
        },
        domProps: { value: _vm.validate.$model },
        on: {
          change: [
            function ($event) {
              return _vm.$set(_vm.validate, "$model", $event.target.value)
            },
            _vm.setUserInfoPatch,
          ],
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }